import { createFileRoute, notFound } from '@tanstack/react-router';
import {
  OrganizationSwitcher,
  SignedIn,
  useOrganization,
  UserProfile,
} from '@clerk/clerk-react';
import { canAccess } from '~/utils/rbac';

export const Route = createFileRoute('/_authLayout/user')({
  beforeLoad: async () => {
    if (!canAccess('user')) {
      throw notFound();
    }
  },
  component: UserComponent,
});

function UserComponent() {
  const { organization } = useOrganization();

  return (
    <div className="p-5">
      {/* Todo: remove signedIn from here. */}
      <SignedIn>
        {!organization ? (
          <OrganizationSwitcher hidePersonal={true} />
        ) : (
          <>
            <OrganizationSwitcher hidePersonal={true} />
            <UserProfile />
          </>
        )}
      </SignedIn>
    </div>
  );
}
